import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../../components/Button/Button";
import Modal from "../../components/modal/Modal";
import BasicModal from "../../components/basic-modal/BasicModal";
import AddVoucherPayment from "../../components/add-voucher-payment/add-voucher-payment";
import AddOneVoucherPayment from "../../components/add-one-voucher-payment/add-one-voucher-payment";
import FloatingLabelInput from "../../components/FloatingLabelInput/FloatingLabelInput";
import zonkeEnergyTCs from "../../utils/zonkeTCs";
import { useForm } from "react-hook-form";
import { ADMIN_LOGIN } from "../../utils/routes";

const PublicTopUp = () => {
  const [payByVoucherModal, setPayByVoucherModal] = useState(false);
  const [payByOneVoucherModal, setPayByOneVoucherModal] = useState(false);
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [clientId, setClientId] = useState(null);

  const location = useLocation();

  // The landing page already asked for the client number, so carry it over
  // rather than making the client type it again.
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: { clientNumber: location.state?.clientNumber ?? "" },
  });

  const onPayByVoucherClose = () => setPayByVoucherModal(false);
  const onPayByOneVoucherClose = () => setPayByOneVoucherModal(false);
  const onTermsAndConditions = () => setShowTermsAndConditions(true);
  const onTermsAndConditionsClose = () => setShowTermsAndConditions(false);

  const onPayByVoucher = (data) => {
    setClientId(parseInt(data.clientNumber, 10));
    setPayByVoucherModal(true);
  };

  const onPayByOneVoucher = (data) => {
    setClientId(parseInt(data.clientNumber, 10));
    setPayByOneVoucherModal(true);
  };

  return (
    <div className="signup-container">
      <Modal
        modal={showTermsAndConditions}
        onClose={onTermsAndConditionsClose}
        modalSize="large"
      >
        <BasicModal
          title={""}
          body={zonkeEnergyTCs}
          onCancel={onTermsAndConditionsClose}
          isHtml={true}
        />
      </Modal>

      <Modal
        modal={payByVoucherModal}
        onClose={onPayByVoucherClose}
        modalSize="large"
      >
        <AddVoucherPayment onCancel={onPayByVoucherClose} clientId={clientId} />
      </Modal>

      <Modal
        modal={payByOneVoucherModal}
        onClose={onPayByOneVoucherClose}
        modalSize="large"
      >
        <AddOneVoucherPayment
          onCancel={onPayByOneVoucherClose}
          clientId={clientId}
        />
      </Modal>

      <div className="signup-card">
        <div className="signup__logo-wrapper">
          <img
            className="signup__logo"
            src={"/images/zonkelogo.jpg"}
            alt="logo"
          />
        </div>
        <div className="signup__title">Top Up Without Login</div>
        <div className="signup__subtitle">
          Enter your client number to make a voucher payment
        </div>

        <form>
          <div className="form-group">
            <FloatingLabelInput
              type={"text"}
              className={""}
              disabled={false}
              name={"clientNumber"}
              register={register}
              rules={{
                required: "Client number is required",
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Client number must contain only numbers",
                },
              }}
              placeholder={"Client Number"}
              errors={errors}
            />
          </div>

          <div className="public-topup__button-group">
            <Button
              onClick={handleSubmit(onPayByVoucher)}
              name={"Pay by OTT Voucher"}
              className={"button--primary"}
            />
            <Button
              onClick={handleSubmit(onPayByOneVoucher)}
              name={"Pay by One Voucher"}
              className={"button--primary"}
            />
          </div>

          <a href="#" className="zonke-terms" onClick={onTermsAndConditions}>
            Zonke Energy T&apos;s & C&apos;s
          </a>

          <div className="public-topup__login-link">
            Already have an account?{" "}
            <Link to={ADMIN_LOGIN} className="link">
              Login here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PublicTopUp;
